import styled from "styled-components";
import { StyleProps } from "./Home.interface";
import { Container } from "@material-ui/core";

export const HeaderContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.primary};
  text-align: center;
  padding: ${({ theme }) => theme.spacing * 26}px 0 ${({ theme }) => theme.spacing * 16}px;
  color: ${({ theme }) => theme.colors.white};
  > h1 {
    font-size: 36px;
    line-height: 48px;
    font-weight: bold;
  }
  > p {
    font-size: 16px;
    line-height: 24px;
    margin: 0;
  }
  @media screen and (max-width: 690px) {
    padding: ${({ theme }) => theme.spacing * 16}px 0;
  }
`;

export const StyledContainer = styled(Container)`
  && {
    padding: ${({ theme }) => theme.spacing * 20}px
      ${({ theme }) => theme.spacing * 40}px;

    @media screen and (max-width: 960px) {
      padding: 80px 12px;
    }
  }
`;

export const BackgroundContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.darkBlueAlpha};
`;

export const SectionName = styled.h3<StyleProps>`
  font-size: 10px;
  color: ${({ theme }) => theme.colors.grayAlpha};
  text-transform: uppercase;
  line-height: 24px;
  margin: 0;
  letter-spacing: 2px;
  text-align: ${({ center }) => (center ? "center" : "left")};
`;

export const SectionTitle = styled.h1<StyleProps>`
  font-size: 32px;
  color: ${({ theme }) => theme.colors.gray};
  line-height: 32px;
  margin: 0;
  text-align: ${({ center }) => (center ? "center" : "left")};
`;

export const SectionDescription = styled.p<StyleProps>`
  color: ${({ theme }) => theme.colors.lightGray};
  font-size: 16px;
  line-height: 28px;
  text-align: ${({ center }) => (center ? "center" : "left")};
`;
